import { z } from 'zod';

export const ContactEmailSchema = z.object({
  name: z.string().trim().min(1).max(200),
  email: z.string().trim().email().max(320),
  phone: z.string().trim().max(40).optional(),
  message: z.string().trim().min(1).max(5000),
  /** The visitor's selected venue; only used if it belongs to the tenant. */
  locationId: z.string().uuid().optional(),
  /** Honeypot: hidden from people, so a filled value means a bot. */
  website: z.string().max(500).optional(),
});

export type ContactEmailInput = z.infer<typeof ContactEmailSchema>;
